/**
 * Minor Electrical Installation Works Certificate (MEIWC) - BS 7671 Model Form Schema
 *
 * Follows the IET/NICEIC/NAPIT model form for minor electrical works:
 * Part 1: Description of Minor Works
 * Part 2: Presence and Adequacy of Installation Earthing and Bonding
 * Part 3: Circuit Details and Test Results
 * Part 4: Declaration
 */

const EARTHING_ARRANGEMENTS = ['TN-S', 'TN-C-S', 'TN-C', 'TT', 'IT'];
const PRESENCE_OPTIONS = ['Yes', 'No', 'N/A'];
const DEVICE_TYPES = ['MCB Type B', 'MCB Type C', 'MCB Type D', 'RCBO Type B', 'RCBO Type C', 'RCBO Type D', 'BS 88-2', 'BS 88-3', 'BS 3036', 'BS 1361'];
const DEVICE_RATINGS = ['6', '10', '16', '20', '25', '32', '40', '50', '63', '80', '100', '125'];
const RCD_TYPES = ['None', '30mA', '100mA', '300mA', '1000mA', 'RCD Type B', 'RCD Type A'];
const TEST_RESULTS = ['SATISFACTORY', 'UNSATISFACTORY', 'NOT TESTED'];

export default {
  sections: [
    {
      id: 'worksDescription',
      title: 'Part 1: Description of Minor Works',
      fields: [
        { id: 'certificateNumber', type: 'text', label: 'Certificate Number', required: true },
        { id: 'dateOfWorks', type: 'date', label: 'Date of Completion of Works', required: true },
        { id: 'clientName', type: 'text', label: 'Client / Customer Name', required: true },
        { id: 'clientAddress', type: 'textarea', label: 'Client Address' },
        { id: 'installationAddress', type: 'textarea', label: 'Installation Address (if different)', required: true },
        { id: 'descriptionOfWorks', type: 'textarea', label: 'Description of the Minor Works Carried Out', required: true },
        { id: 'existingInstallation', type: 'textarea', label: 'Details of Existing Installation (if relevant)' }
      ]
    },
    {
      id: 'earthingBonding',
      title: 'Part 2: Presence and Adequacy of Installation Earthing and Bonding',
      fields: [
        { id: 'earthingArrangement', type: 'select', label: 'Installation Earthing Arrangement', options: EARTHING_ARRANGEMENTS, required: true },
        { id: 'earthConductor', type: 'select', label: 'Earth Conductor Present and Adequate', options: PRESENCE_OPTIONS, required: true },
        { id: 'mainBonding', type: 'select', label: 'Main Equipotential Bonding Present and Adequate', options: PRESENCE_OPTIONS, required: true },
        { id: 'supplementaryBonding', type: 'select', label: 'Supplementary Bonding Present and Adequate', options: PRESENCE_OPTIONS },
        { id: 'bondingNotes', type: 'textarea', label: 'Earthing / Bonding Notes' }
      ]
    },
    {
      id: 'circuitDetails',
      title: 'Part 3: Circuit Details and Test Results',
      repeatable: true,
      fields: [
        { id: 'circuitNumber', type: 'text', label: 'Circuit Number' },
        { id: 'circuitDescription', type: 'text', label: 'Circuit Description', required: true },
        { id: 'protectiveDevice', type: 'select', label: 'Protective Device Type', options: DEVICE_TYPES, required: true },
        { id: 'deviceRating', type: 'select', label: 'Device Rating', options: DEVICE_RATINGS },
        { id: 'maxZs', type: 'number', label: 'Max Permitted Zs (Ω)', step: 0.01 },
        { id: 'measuredZs', type: 'number', label: 'Measured Zs (Ω)', step: 0.01 },
        { id: 'rcdType', type: 'select', label: 'RCD Type (if RCD protected)', options: RCD_TYPES },
        { id: 'rcdTripTime1x', type: 'number', label: 'RCD Trip Time 1Δn (ms)' },
        { id: 'rcdTripTime5x', type: 'number', label: 'RCD Trip Time 5Δn (ms)' },
        { id: 'insulationResistance', type: 'number', label: 'Insulation Resistance (MΩ)', step: 0.01 },
        { id: 'earthContinuity', type: 'number', label: 'Earth Continuity (R1+R2) (Ω)', step: 0.01 },
        { id: 'testResult', type: 'select', label: 'Test Result', options: TEST_RESULTS, required: true },
        { id: 'notes', type: 'textarea', label: 'Notes' }
      ]
    },
    {
      id: 'declaration',
      title: 'Part 4: Declaration',
      fields: [
        { id: 'engineerName', type: 'text', label: 'Engineer / Qualified Supervisor Name', required: true },
        { id: 'engineerCardNumber', type: 'text', label: 'Engineer Card / License Number', required: true },
        { id: 'companyName', type: 'text', label: 'Company Name' },
        { id: 'schemeName', type: 'text', label: 'Competent Persons Scheme' },
        { id: 'schemeReference', type: 'text', label: 'Scheme Registration Reference' },
        { id: 'engineerSignature', type: 'signature', label: 'Engineer Signature' },
        { id: 'customerSignature', type: 'signature', label: 'Customer / Client Signature' }
      ]
    }
  ]
};